module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Toko")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/toko"
    }
  }, [_vm._v("Master Data")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding-left": "20px",
      "padding-top": "10px"
    }
  }, [_c('h4', [_c('b', [_vm._v("MASTER DATA")])])]), _vm._v(" "), (_vm.level === 'ROOT') ? _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding-right": "20px",
      "padding-top": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.addData()
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.tableData1,
      "max-height": "550",
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "#",
      "header-align": "center",
      "align": "center",
      "width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                            " + _vm._s(scope.row.kode) + "\n                          ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "NAMA TOKO",
      "prop": "nama",
      "header-align": "left",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Toko"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariNama()
            }
          },
          model: {
            value: (_vm.cari_nama),
            callback: function($$v) {
              _vm.cari_nama = $$v
            },
            expression: "cari_nama"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.nama))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "WILAYAH",
      "prop": "wilayah",
      "header-align": "left",
      "align": "left",
      "width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Wilayah"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariWilayah()
            }
          },
          model: {
            value: (_vm.cari_wilayah),
            callback: function($$v) {
              _vm.cari_wilayah = $$v
            },
            expression: "cari_wilayah"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.wilayah))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "STATUS",
      "prop": "status",
      "header-align": "center",
      "align": "center",
      "width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(scope.row.status) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "PILIHAN",
      "align": "center",
      "header-align": "center",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Detail",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "icon": "el-icon-search"
          },
          on: {
            "click": function($event) {
              return _vm.confirmEdit(scope.$index, scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (!scope.row.edit) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Buka",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small",
            "icon": "el-icon-refresh"
          },
          on: {
            "click": function($event) {
              return _vm.confirmOpen(scope.row)
            }
          }
        })], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.tableData.length,
      "page-size": _vm.page_size,
      "current-page": _vm.current_page
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdd),
      expression: "loadingModalAdd"
    }],
    attrs: {
      "title": "Tambah Data",
      "visible": _vm.dialogFormVisible,
      "width": "500px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nama",
      "prop": "nama"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.nama),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nama", $$v)
      },
      expression: "row1.nama"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Alamat",
      "prop": "alamat"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.alamat),
      callback: function($$v) {
        _vm.$set(_vm.row1, "alamat", $$v)
      },
      expression: "row1.alamat"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Region",
      "prop": "kode_region"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearchRegion,
      "placeholder": "Cari Region"
    },
    on: {
      "select": _vm.handleSelectRegion
    },
    model: {
      value: (_vm.region1_),
      callback: function($$v) {
        _vm.region1_ = $$v
      },
      expression: "region1_"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Wilayah",
      "prop": "kode_wilayah"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearchWilayah,
      "placeholder": "Cari Wilayah"
    },
    on: {
      "select": _vm.handleSelectWilayah
    },
    model: {
      value: (_vm.wilayah1),
      callback: function($$v) {
        _vm.wilayah1 = $$v
      },
      expression: "wilayah1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Area",
      "prop": "kode_area"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearchArea,
      "placeholder": "Cari Area"
    },
    on: {
      "select": _vm.handleSelectArea
    },
    model: {
      value: (_vm.area1),
      callback: function($$v) {
        _vm.area1 = $$v
      },
      expression: "area1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Cabang",
      "prop": "kode_cabang"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearch1,
      "placeholder": "Cari Cabang"
    },
    on: {
      "select": _vm.handleSelect_1
    },
    model: {
      value: (_vm.cabang1),
      callback: function($$v) {
        _vm.cabang1 = $$v
      },
      expression: "cabang1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Toko Jenis",
      "prop": "kode_toko_jenis"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "Cari Jenis Toko"
    },
    on: {
      "select": _vm.handleSelect_
    },
    model: {
      value: (_vm.region1),
      callback: function($$v) {
        _vm.region1 = $$v
      },
      expression: "region1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Pajak",
      "prop": "kode_pajak"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Pilih Pajak"
    },
    on: {
      "change": _vm.ubahKodePajak
    },
    model: {
      value: (_vm.keterangan_pajak),
      callback: function($$v) {
        _vm.keterangan_pajak = $$v
      },
      expression: "keterangan_pajak"
    }
  }, _vm._l((_vm.pajak), function(item) {
    return _c('el-option', {
      key: item.kode,
      attrs: {
        "label": item.value,
        "value": item.kode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Investasi Pembangunan Toko",
      "prop": "investasi_pembangunan"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.investasi_pembangunan),
      callback: function($$v) {
        _vm.$set(_vm.row1, "investasi_pembangunan", $$v)
      },
      expression: "row1.investasi_pembangunan"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sewa Toko",
      "prop": "sewa_toko"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.sewa_toko),
      callback: function($$v) {
        _vm.$set(_vm.row1, "sewa_toko", $$v)
      },
      expression: "row1.sewa_toko"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tanggal Jatuh Tempo",
      "prop": "jatuh_tempo_sewa_toko"
    }
  }, [_vm._v("\n                   \n                  "), _c('el-date-picker', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Jenis Cutoff",
      "prop": "cutoff_jenis_kode"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearchJenis,
      "placeholder": "Cari Jenis Cutoff"
    },
    on: {
      "select": _vm.handleSelectJenis
    },
    model: {
      value: (_vm.cutoff_jenis_nama),
      callback: function($$v) {
        _vm.cutoff_jenis_nama = $$v
      },
      expression: "cutoff_jenis_nama"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalEdit),
      expression: "loadingModalEdit"
    }],
    attrs: {
      "title": "Edit Data",
      "visible": _vm.dialogFormEdit,
      "width": "500px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "formEdit",
    attrs: {
      "label-position": "top",
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nama",
      "prop": "nama"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.nama),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nama", $$v)
      },
      expression: "row1.nama"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Alamat",
      "prop": "alamat"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.alamat),
      callback: function($$v) {
        _vm.$set(_vm.row1, "alamat", $$v)
      },
      expression: "row1.alamat"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Region",
      "prop": "kode_region"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearchRegion,
      "placeholder": "Cari Region",
      "disabled": _vm.level.indexOf('ADMIN') !== -1
    },
    on: {
      "select": _vm.handleSelectRegion
    },
    model: {
      value: (_vm.region1_),
      callback: function($$v) {
        _vm.region1_ = $$v
      },
      expression: "region1_"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Wilayah",
      "prop": "kode_wilayah"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearchWilayah,
      "placeholder": "Cari Wilayah",
      "disabled": _vm.level.indexOf('ADMIN') !== -1
    },
    on: {
      "select": _vm.handleSelectWilayah
    },
    model: {
      value: (_vm.wilayah1),
      callback: function($$v) {
        _vm.wilayah1 = $$v
      },
      expression: "wilayah1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Area",
      "prop": "kode_area"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearchArea,
      "placeholder": "Cari Area"
    },
    on: {
      "select": _vm.handleSelectArea
    },
    model: {
      value: (_vm.area1),
      callback: function($$v) {
        _vm.area1 = $$v
      },
      expression: "area1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Cabang",
      "prop": "kode_cabang"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearch1,
      "placeholder": "Cari Cabang"
    },
    on: {
      "select": _vm.handleSelect_1
    },
    model: {
      value: (_vm.cabang1),
      callback: function($$v) {
        _vm.cabang1 = $$v
      },
      expression: "cabang1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Toko Jenis",
      "prop": "kode_toko_jenis"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "Cari Jenis Toko"
    },
    on: {
      "select": _vm.handleSelect_
    },
    model: {
      value: (_vm.region1),
      callback: function($$v) {
        _vm.region1 = $$v
      },
      expression: "region1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Pajak",
      "prop": "kode_pajak"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Pilih Pajak"
    },
    on: {
      "change": _vm.ubahKodePajak
    },
    model: {
      value: (_vm.keterangan_pajak),
      callback: function($$v) {
        _vm.keterangan_pajak = $$v
      },
      expression: "keterangan_pajak"
    }
  }, _vm._l((_vm.pajak), function(item) {
    return _c('el-option', {
      key: item.kode,
      attrs: {
        "label": item.value,
        "value": item.kode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Investasi Pembangunan Toko",
      "prop": "investasi_pembangunan"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.investasi_pembangunan),
      callback: function($$v) {
        _vm.$set(_vm.row1, "investasi_pembangunan", $$v)
      },
      expression: "row1.investasi_pembangunan"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "label": "Sewa Toko",
      "prop": "sewa_toko"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "275px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.sewa_toko),
      callback: function($$v) {
        _vm.$set(_vm.row1, "sewa_toko", $$v)
      },
      expression: "row1.sewa_toko"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Jenis Cutoff",
      "prop": "cutoff_jenis_kode"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearchJenis,
      "placeholder": "Cari Jenis Cutoff"
    },
    on: {
      "select": _vm.handleSelectJenis
    },
    model: {
      value: (_vm.cutoff_jenis_nama),
      callback: function($$v) {
        _vm.cutoff_jenis_nama = $$v
      },
      expression: "cutoff_jenis_nama"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Admin Toko",
      "prop": "admin"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "370px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.admin),
      callback: function($$v) {
        _vm.$set(_vm.row1, "admin", $$v)
      },
      expression: "row1.admin"
    }
  }), _vm._v(" "), (_vm.level === 'ROOT') ? _c('el-button', {
    attrs: {
      "type": "warning",
      "size": "small",
      "icon": "ti-user"
    },
    on: {
      "click": function($event) {
        return _vm.editAdmin2()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Admin Area",
      "prop": "admin"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "370px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.admin_area),
      callback: function($$v) {
        _vm.$set(_vm.row1, "admin_area", $$v)
      },
      expression: "row1.admin_area"
    }
  }), _vm._v(" "), (_vm.level === 'ROOT') ? _c('el-button', {
    attrs: {
      "type": "warning",
      "size": "small",
      "icon": "ti-user"
    },
    on: {
      "click": function($event) {
        return _vm.editAdmArea2()
      }
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormEdit = false
      }
    }
  }, [_vm._v("Tutup")]), _vm._v(" "), ((_vm.level === 'ROOT' || _vm.level === 'ADMIN TOKO')) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1(0, _vm.row1, 'formEdit')
      }
    }
  }, [_vm._v("Simpan Perubahan")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalEditAdmin),
      expression: "loadingModalEditAdmin"
    }],
    attrs: {
      "title": "Pilih Admin",
      "visible": _vm.dialogFormEditAdmin,
      "width": "500px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormEditAdmin = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Cari Admin"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.handleSelect.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.carinama),
      callback: function($$v) {
        _vm.carinama = $$v
      },
      expression: "carinama"
    }
  }), _vm._v(" \n              "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdmin),
      expression: "loadingModalAdmin"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.admin,
      "highlight-current-row": "",
      "responsive": ""
    },
    on: {
      "current-change": _vm.handleCurrentChangeAdmin
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "#",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.$index + 1) + "\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "Nama",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.nama) + "\n                  ")]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormEditAdmin = false
      }
    }
  }, [_vm._v("Tutup")]), _vm._v(" "), (_vm.level === 'ROOT') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEditAdmin1(0, _vm.row1, 'formEditAdmin')
      }
    }
  }, [_vm._v("Simpan")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalEditAdmArea),
      expression: "loadingModalEditAdmArea"
    }],
    attrs: {
      "title": "Edit Admin Area",
      "visible": _vm.dialogFormEditAdmArea,
      "width": "500px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormEditAdmArea = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Cari Admin Area"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.handleSelect1.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.carinama1),
      callback: function($$v) {
        _vm.carinama1 = $$v
      },
      expression: "carinama1"
    }
  }), _vm._v(" \n              "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdmArea),
      expression: "loadingModalAdmArea"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.admarea,
      "highlight-current-row": "",
      "responsive": ""
    },
    on: {
      "current-change": _vm.handleCurrentChangeAdmArea
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "#",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.$index + 1) + "\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "Nama",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.nama) + "\n                  ")]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormEditAdmArea = false
      }
    }
  }, [_vm._v("Tutup")]), _vm._v(" "), (_vm.level === 'ROOT') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEditAdmArea1(0, _vm.row1, 'formEditAdmArea')
      }
    }
  }, [_vm._v("Simpan")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalEditKacab),
      expression: "loadingModalEditKacab"
    }],
    attrs: {
      "title": "Edit Kacab",
      "visible": _vm.dialogFormEditKacab,
      "width": "500px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormEditKacab = $event
      }
    }
  }, [_c('el-form', {
    ref: "formEditKacab",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nama",
      "prop": "nama"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.row1.nama),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nama", $$v)
      },
      expression: "row1.nama"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v("\n                  Search  \n                "), _c('el-input', {
    attrs: {
      "placeholder": "Cari Kacab"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.handleSelect2.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.carinama2),
      callback: function($$v) {
        _vm.carinama2 = $$v
      },
      expression: "carinama2"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalKacab),
      expression: "loadingModalKacab"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.kacab,
      "highlight-current-row": "",
      "responsive": ""
    },
    on: {
      "current-change": _vm.handleCurrentChangeKacab
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "#",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.$index + 1) + "\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "Nama",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.nama) + "\n                  ")]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormEditKacab = false
      }
    }
  }, [_vm._v("Tutup")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEditKacab1(0, _vm.row1, 'formEditKacab')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalOpen),
      expression: "loadingModalOpen"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormOpen,
      "width": "500px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormOpen = $event
      }
    }
  }, [_c('h4', [_vm._v("Apakah Anda yakin akan membuka kembali toko "), _c('b', [_vm._v(_vm._s(_vm.nama))]), _vm._v(" ?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormOpen = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmOpen1()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDel),
      expression: "loadingModalDel"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormWilDel,
      "width": "500px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormWilDel = $event
      }
    }
  }, [_c('h4', [_vm._v("Apakah Anda yakin akan menghapus toko " + _vm._s(_vm.nama) + "?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormWilDel = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDel1()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Info",
      "visible": _vm.dialogFormInfo,
      "width": "500px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormInfo = $event
      }
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormInfo = false
      }
    }
  }, [_vm._v("OK")])], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-abe29b6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/master_data/Toko1.vue
// module id = 1431
// module chunks = 2